import React from 'react'
import DetailCard from './DetailCard'
import DetailRows from './DetailRows'
import MeterIcon from '@/assets/DetailsCards_icons/meter_technical_info_icon.png'
import { buildDetailCards, cardTitles } from '@/utils/consumerDetailCards'

interface TransmitterInfoCardProps {
  data?: any
  resourceHeaders?: Record<string, string>
  langKey?: string
}

const TransmitterInfoCard: React.FC<TransmitterInfoCardProps> = ({
  data,
  resourceHeaders = {},
  langKey = 'he',
}) => (
  <DetailCard
    title={cardTitles(langKey).transmitter}
    icon={
      <img
        src={MeterIcon}
        alt="transmitter"
        style={{ width: 18, height: 18, transform: 'scaleX(-1)' }}
      />
    }
    fitContent
  >
    <DetailRows
      rows={buildDetailCards(data, resourceHeaders, langKey).transmitter}
      emptyMessage={
        langKey === 'he' ? 'אין פרטי משדר להצגה' : 'No transmitter details'
      }
    />
  </DetailCard>
)

export default TransmitterInfoCard
